import { useEffect, FC } from 'react'
import { noop } from 'lodash-es'
import { Shareable, PublishableResource } from '@app-types/entity_types'
import { SerializableError } from '@app-types/general'
import PublishStatus from '@constants/publish_statuses'
import RequestStatus from '@constants/request_statuses'
import TreeModal, { ModalStep, ModalHeader } from '@components/modals/TreeModal'
import StartStep from './classic/StartStep'
import PermissionManagementStartStep from '../../resource_permissions/components/steps/StartStep'
import UserPermissionsStep from '../../resource_permissions/components/steps/UserPermissionsStep'
import GroupPermissionsStep from '../../resource_permissions/components/steps/GroupPermissionsStep'
import EmbedStep from './classic/EmbedStep'

interface ClassicSharerProps {
  loadShareable: (id: number, type: string) => void
  shareableType: string
  shareableId: number
  shareable?: Shareable
  resource?: PublishableResource
  status?: RequestStatus
  error?: SerializableError
  show?: boolean
  onClose?: () => void
}

const ClassicSharer: FC<ClassicSharerProps> = ({
  loadShareable,
  shareable,
  resource,
  shareableId,
  shareableType,
  status,
  error,
  show = false,
  onClose = noop,
}) => {
  const isPublished = resource?.publish_status_code === PublishStatus.PUBLISHED

  useEffect(() => {
    loadShareable(shareableId, shareableType)
  }, [loadShareable, shareableId, shareableType])

  const resourceId = shareableId
  const resourceType = shareableType

  return (
    <TreeModal show={show} onClose={onClose} initialStepId="start" className="tree-modal qa-classic-sharer">
      <ModalStep stepId="start" header={<ModalHeader title="Share" showBackButton={false} />}>
        <StartStep
          shareable={shareable}
          status={status || RequestStatus.IDLE}
          error={error}
          isPublished={isPublished}
        />
      </ModalStep>
      <ModalStep stepId="embed" header={<ModalHeader title="Embed" />}>
        <EmbedStep shareable={shareable} status={status || RequestStatus.IDLE} isPublished={isPublished} />
      </ModalStep>
      <ModalStep stepId="permissionsManagement" header={<ModalHeader title="Permissions & Access" />}>
        <PermissionManagementStartStep resourceId={resourceId} resourceType={resourceType} />
      </ModalStep>
      <ModalStep stepId="userPermissions" header={<ModalHeader title="User Access" />}>
        <UserPermissionsStep resourceId={resourceId} resourceType={resourceType} />
      </ModalStep>

      <ModalStep stepId="groupPermissions" header={<ModalHeader title="Group Access" />}>
        <GroupPermissionsStep resourceId={resourceId} resourceType={resourceType} />
      </ModalStep>
    </TreeModal>
  )
}

export default ClassicSharer
